import React, { useRef, useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Images from "../images";
import LazyImg from "./LazyImg";
import SignIn from "./SignIn";
import { useLocation, Link } from "react-router-dom";
import axiosInstance from "../Help/AxiosLogicInstance";
import "./ApplicationBanner.css";
const InternShipResearchProgram = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formSource, setFormSource] = useState("");
  const token = localStorage.getItem("token");
  const [showSignIn, setShowSignIn] = useState(false);
  const { setActiveModal } = useOutletContext();
  const [isFormActive, setIsFormActive] = useState(false);

  const faqs = [
    {
      question: "How to approach Metropolis Health care for Internship?",
      answer:
        "To approach for Internship at Metropolis Healthcare limited one need to visit MedEngage website and apply online",
    },
    {
      question: "What is the minimum length of the Internship at MHL?",
      answer: "1 to 6 months",
    },
    {
      question:
        "Will Metropolis give the intern a certificate of completion of the Internship?",
      answer: "Yes",
    },
    {
      question:
        "Will applicant get a choice of themes while applying for Internship?",
      answer: "Yes",
    },
    {
      question:
        "Can Metropolis be contacted even after 6 months ( Post Internship)?",
      answer: "Yes",
    },
    {
      question: "What is the maximum length of the internship at MHL ?",
      answer: "6 Months",
    },
  ];
  const [hoveredCard, setHoveredCard] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Internship Research Program - MedEngage";
  }, []);

  // Check if the form is active
  useEffect(() => {
    const checkFormStatus = async () => {
      try {
        const response = await axiosInstance.get('/api/Student/GetApplicationSettingMasterByFormId/2');
        if (response.data && 
            response.data.Status === "200" && 
            response.data.Data && 
            response.data.Data.length > 0) {
          setIsFormActive(response.data.Data[0].IsActive);
        } else {
          setIsFormActive(false);
        }
      } catch (error) {
        console.error("Error fetching form status:", error);
        setIsFormActive(false);
      }
    };
    
    checkFormStatus();
  }, []);
  
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);

  const contacts = [
    {
      id: 1,
      title: "Registration & Application",
      email: "application@med-engage.com",
      gradient: "lightblue",
      icon: "📋",
      description: "Start your medical journey with us",
    },
    {
      id: 2,
      title: "Support & Contact",
      email: "support@med-engage.com",
      gradient: "lightgreen",
      icon: "🚀",
      description: "Get help when you need it",
    },
    {
      id: 3,
      title: "Academics",
      email: "academics.sciencecell@metropolisindia.com",
      gradient: "lightpink",
      icon: "🎯",
      description: "Academic excellence support",
    },
  ];

  const teamMembers = [
    {
      id: 1,
      name: "Shalini Sahay",
      email: "shalini.sahay@metropolisindia.com",
      phone: "+91 9310554590",
      gradient: "lightcoral",
      avatar: "SS",
      role: "Team Lead",
    },
    {
      id: 2,
      name: "Jeyasingh B",
      email: "jeyasingh.b@metropolisindia.com",
      phone: "+91 8928286168",
      gradient: "lightseagreen",
      avatar: "JB",
      role: "Secondary Contact",
    },
  ];
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}
      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">Internship Research Program</h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                 <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>Internship Research Program</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                    Internship{" "}
                    <span>
                      <strong className="green"> Research Program </strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                    Under CSR initiative, the Internship Research Programme is
                    an important pillar. It aims to provide support for research
                    for a period of 6 (six) months under guidance of experts
                    under Metropolis Healthcare Limited. The intern works in
                    unison with seasoned and experienced professionals in MHL
                    who coaches the Intern in doing effective research and post
                    that the intern submits the research proposal to MHL.
                  </p>

                  <p className="ul-section-descr">
                    Such initiative will play a pivotal role in changing the
                    landscape of the healthcare industry in India and encourage
                    innovations and research.
                  </p>
                </div>
              </div>

              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper text-center">
                    <LazyImg
                      src={Images.Internshipprogram}
                      alt="Internship Research Program"
                      className="scholarship-image rounded-3"
                    />
                    <div className="img-caption mt-2">
                      Internship Research Program
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="section-spacing bg-light ul-section-spacing">
          <div class="container">
            <div class="text-center mb-5 px-3">
              <h3 className="ul-section-title text-center">
                Eligibility & SOP for the{" "}
                <span className="version green">
                  {" "}
                  Internship Research Program
                </span>
              </h3>
              <p class="section-subtitle">SOP Steps</p>
            </div>

            <div className="row g-4 mb-5">
              {[
                {
                  num: 1,
                  title: "Eligibility",
                  desc: "Support is available only for medical/research students and members of the medical fraternity (MBBS, MD, DNB, PhD, or others).",
                },
                {
                  num: 2,
                  title: "Application Review",
                  desc: "Support is granted only after a thorough scrutiny of the academic justification by the Academic Cell.",
                },
                {
                  num: 3,
                  title: "Beneficiary",
                  desc: "The support will be extended directly to the student or doctor.",
                },
                {
                  num: 4,
                  title: "Financial Terms",
                  desc: "Laboratory research support is provided on a no-profit-no-loss basis.",
                },
              ].map((step) => (
                <div key={step.num} className="col-12 col-md-6">
                  <div className={`card-step step-${step.num} h-100`}>
                    <div className="d-flex align-items-center mb-3 justify-content-start">
                      <span className="step-badge me-2">{step.num}</span>
                      <strong className="fs-6">{step.title}</strong>
                    </div>
                    <div>{step.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="ul-about ul-section-spacing">
          <div className="ul-container application-banner">
            <div className="row align-items-center">
              {/* Left Illustration */}
              <div className="col-md-6 mb-3 mb-md-0 text-center text-md-start">
                <LazyImg
                  src={Images.Internshipvector}
                  alt="Internship illustration"
                  className="img-fluid"
                />
              </div>

              {/* Right Text */}
              <div className="col-md-6 banner-text text-center text-md-start">
                <h2 className="mb-2 fw-bold">Internship Research Program</h2>
                <p className="mb-3">
                  Apply now and take your first step to success.
                </p>

                <div className="d-flex flex-column flex-sm-row align-items-center gap-2 justify-content-center justify-content-md-start">
                  {isFormActive ? (
                    token ? (
                      <button
                        className="btn-login btn-lg"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/internship-application/");
                        }}
                      >
                        Apply
                      </button>
                    ) : (
                      <button
                        className="btn-login d-flex align-items-center gap-2"
                        onClick={() => {
                          const token = localStorage.getItem("token");
                          if (token) {
                            navigate("/internship-application/");
                          } else {
                            setActiveModal("signIn"); // open SignIn modal
                          }
                        }}
                      >
                        Login
                      </button>
                      )
                  ) : (
                    <div className="alert alert-info mb-0">
                      Applications are currently closed. Please check back later.
                    </div>
                  )}

                  {showSignIn && (
                    <SignIn
                      show={showSignIn}
                      handleClose={() => setShowSignIn(false)}
                      from={formSource}
                    />
                  )}

                  <LazyImg
                    src={Images.Arrow}
                    alt="decorative arrow"
                    className="img-fluid ms-5 arrow-image   d-none d-lg-inline-block"
                    style={{ transform: "rotate(70deg)" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="faq-section">
          <div className="ul-container">
            <h2 className="ul-section-title text-center p-2 m-2">FAQs</h2>
            <div className="faq-container">
              <div className="faq-grid">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className="faq-item"
                    onClick={() => toggleFAQ(index)}
                  >
                    <div style={{ flex: 1 }}>
                      <span className="faq-question">{faq.question}</span>
                      <div
                        className={`faq-answer ${
                          openIndex === index ? "show" : ""
                        }`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {faq.answer}
                      </div>
                    </div>
                    <span className="faq-icon">
                      <LazyImg
                        src={openIndex === index ? Images.Minus : Images.Plus}
                        alt={openIndex === index ? "Collapse" : "Expand"}
                        className="faq-toggle-icon"
                      />
                    </span>
                  </div>
                ))}
              </div>
              {/*   <div className="text-center mt-4">
                <button className="btn-view">View All</button>
              </div> */}
            </div>
          </div>
        </section>

        <section className="med-cards-section py-4 py-md-5">
          <div className="container-fluid px-3 px-md-5">
            {/* Department Contacts */}
            <div className="row g-2 g-md-2 mb-3 mb-md-5 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-4">
                <h2 className="fw-bold">
                  <span className="text-success">Contact</span> Information
                </h2>
                <div className="divider mx-auto"></div>
              </div>
              {contacts.map((contact, index) => (
                <div
                  key={contact.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card department-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`dept-${contact.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <div className="contact-card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="icon-container"
                        style={{ background: contact.gradient }}
                      >
                        <span className="icon-emoji">{contact.icon}</span>
                        <div className="pulse-ring"></div>
                      </div>

                      <h6 className="card-title mb-2">{contact.title}</h6>
                      <p className="card-description text-muted">
                        {contact.description}
                      </p>

                      <div className="email-container">
                        <a
                          href={`mailto:${contact.email}`}
                          className="email text-success"
                          title={contact.email}
                        >
                          {contact.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Team Members */}
            <div className="row g-2 g-md-2 justify-content-center">
              <div className="col-12 text-center mb-1 mb-md-3">
                <div className="divider mx-auto"></div>
              </div>

              {teamMembers.map((member, index) => (
                <div
                  key={member.id}
                  className="col-12 col-sm-6 col-lg-4 d-flex"
                >
                  <div
                    className="contact-card team-card flex-fill"
                    onMouseEnter={() => setHoveredCard(`team-${member.id}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{ animationDelay: `${(index + 3) * 0.1}s` }}
                  >
                    <div className="card-content text-center p-2 h-100 d-flex flex-column justify-content-between">
                      <div
                        className="avatar-container"
                        style={{ background: member.gradient }}
                      >
                        <span className="avatar-text">{member.avatar}</span>
                        <div className="avatar-ring"></div>
                      </div>

                      <h4 className="member-name mb-2">{member.name}</h4>

                      <div className="contact-info d-flex flex-column gap-1 w-100">
                        <div className="email-container">
                          <a
                            href={`mailto:${member.email}`}
                            className="email text-success"
                          >
                            {member.email}
                          </a>
                        </div>
                        {member.phone && (
                        <div className="email-container">
                          <a
                            href={`tel:${member.phone}`}
                            className="email text-dark"
                          >
                            {member.phone}
                          </a>
                        </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default InternShipResearchProgram;
